
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import SemiTrailerList from './List';
import SemiTrailerAdd from './Add';
import SemiTrailerDetail from './Detail';


export default class SemiTrailerRoutes extends Component {
  render() {
    return (
      <Switch>
        <Route path="/semi_trailer" exact component={SemiTrailerList} />
        <Route path="/semi_trailer/add" exact component={SemiTrailerAdd} />
        <Route path="/semi_trailer/:id" component={SemiTrailerDetail} />
      </Switch>
    );
  }
}
